// extracted by mini-css-extract-plugin
export default {"mCard":"Yx-z","image":"Zx-z","imageNoBackground":"_x-z","fullWidth":"ay-z"};